angular.module('membership')
  .controller('RoleInfoCtrl', ['$scope', '$stateParams', 'roleInfoViewModel',

    function ($scope, $stateParams, model) {
      $scope.model = new model($stateParams.id);
    }
  ])